import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Heading, VStack, Center, Spinner, Text } from '@chakra-ui/react';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { PodcastCard } from '@src/components/sco/Education/PodcastLanding/PodcastCard';
import { gql, gqlArgs, gqlVars } from '@src/lib/gql';
import moment from 'moment';
import { Fade } from 'react-awesome-reveal';
type PodcastListProps = {
  keywords?: string;
  termSlugs?: string[];
  title?: string;
  excludeFirst?: boolean;
};
export const PodcastList = props => {
  const $ = _c(20);
  let t0;
  if ($[0] !== props) {
    t0 = PodcastList.queries.podcastEpisodes(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.keywords || $[3] !== props.termSlugs) {
    t1 = {
      variables: {
        keywords: props.keywords,
        termSlugs: props.termSlugs
      }
    };
    $[2] = props.keywords;
    $[3] = props.termSlugs;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const podcastQuery = useQuery(t0, t1);
  useEducationContext();
  if (podcastQuery.loading || !podcastQuery.data) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center><Spinner /></Center>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (podcastQuery.error) {
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <>Error</>;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  if (podcastQuery.data.podcastEpisodes?.length === 0) {
    let t2;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center padding={8}><Text textStyle="labelMd">No results found for this topic</Text></Center>;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t2;
  if ($[8] !== props.title) {
    t2 = <Heading size="4xl">{props.title}</Heading>;
    $[8] = props.title;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== podcastQuery.data.podcastEpisodes || $[11] !== props.excludeFirst) {
    let t4;
    if ($[13] !== props.excludeFirst) {
      t4 = (episode, index) => !props.excludeFirst || index > 0;
      $[13] = props.excludeFirst;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = podcastQuery.data.podcastEpisodes.filter(t4).map(_temp);
    $[10] = podcastQuery.data.podcastEpisodes;
    $[11] = props.excludeFirst;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[15] !== t3) {
    t4 = <VStack gap={20} width="full">{t3}</VStack>;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t2 || $[18] !== t4) {
    t5 = <VStack align="flex-start" gap={10} width="full">{t2}{t4}</VStack>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
PodcastList.fragments = {
  PodcastEpisode: () => gql`
    fragment _ on PodcastEpisode {
      id
      title
      releaseDate
      description
      slug
      posterImage {
        id
        url
        altText
        height
        width
      }
      number
      slug
    }
  `
};
PodcastList.queries = {
  podcastEpisodes: (props: PodcastListProps) => {
    const vars = gqlVars({
      '$keywords: String': props.keywords,
      '$termSlugs: [String]': props.termSlugs?.length > 0
    });
    const where = gqlArgs({
      'where: ': {
        '_search: $keywords': props.keywords,
        'terms_some: { slug_in: $termSlugs }': props.termSlugs?.length > 0
      }
    });
    return gql`
      query ${vars} {
        podcastEpisodes(
          orderBy: number_DESC
          ${where}
        ) {
          id
          ${PodcastList.fragments.PodcastEpisode()}
        }
      }
    `;
  }
};
function _temp(episode_0, index_0) {
  return <Fade key={index_0} duration={1500} style={{
    width: "100%"
  }} triggerOnce={true}><PodcastCard key={episode_0.id} image={episode_0.posterImage?.url} releaseDate={moment(episode_0.releaseDate).format("MMMM D, YYYY")} summary={episode_0.description} tag={`${episode_0.number}`} title={episode_0.title} url={`/podcast/${episode_0.slug}`} /></Fade>;
}